import {
  HexIcon,
  Icons,
  Placeholder as StatusMessage,
} from '@cast/design-system';

export const ErrorPage404 = () => {
  return (
    <StatusMessage
      stackProps={{ mt: 180 }}
      icon={<HexIcon variant="error" icon={<Icons.Question weight="fill" />} />}
      title="Error 404"
      titleProps={{ variant: 'h4' }}
      body="Page not found"
      bodyProps={{ variant: 'P16R' }}
      testId="error-page"
    />
  );
};
